import {
  Box,
  ListItemIcon,
  ListItemText,
  Slider,
  SxProps,
  Typography,
  useMediaQuery,
} from '@mui/material';
import Reset from 'assets/images/Repertoire/Reset.svg';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import LeftArrowIcon from 'assets/images/LeftArrowIcon.png';
import InfoIcon from 'assets/images/InfoIcon.png';
import Chevron1 from 'assets/images/Chevron1.png';
import ChevronSingle from 'assets/images/ChevronSingle.png';
import ChevronFilled from 'assets/images/ChevronFilled.png';
import ChevronLastFilled from 'assets/images/ChevronLastFilled.png';
import MinusIcon from 'assets/images/MinusIcon.png';
import PlusIcon from 'assets/images/PlusIcon.png';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import * as appActions from 'Actions/app';
import * as eventActions from 'Actions/events';
import * as lessonActions from 'Actions/lesson';

import { ERROR_RECOGNITION_MODE, MainAppReducer } from 'Types';
// import { Levels } from '../../Constants/LevelData'
import { useNavigate } from 'react-router-dom';
import {
  useState,
  useEffect,
  useRef,
  useCallback,
  FC,
  ReactNode,
  StrictMode,
  Dispatch,
  SetStateAction,
} from 'react';
import { BPM, MIN_NUM_PHRASES } from 'Utils/Constants';
import './Lesson.css';
import RepertoireUnlocked from './RepertoireUnlocked';
import TierWrapUp from './TierWrapUp';
import UnitComplete from './UnitComplete';
import FooterContainer from './Footer';
// PauseContainer removed - now we skip the confirmation and go directly to wrap up or roadmap
import { range, set } from 'lodash'
import { colors, inProgressContainerStyles, completeContainerStyles } from 'Components/RoadmapComponents/Path';
import {v4 as uuid} from 'uuid';
import { MUSEFLOW_ORANGE } from 'Components/Colors';
import { AuthReducer } from 'Types/AuthTypes';
import { LessonReducer } from 'Reducers/lessonReducer';
import { RepertoireReducer } from 'Types/RepertoireTypes';
import { WrapUpModalPage } from 'Types/LessonTypes';
import logger from 'Utils/Logger';
import { sortBy } from 'lodash';
import Modal from 'Components/TierWrapUp/Modal';
import { useMediaQueries } from 'Hooks/useMediaQueries';
import { useHoldToRepeat } from 'Hooks/useHoldToRepeat';
import Navigation from 'Components/TierWrapUp/Navigation';
import BackToRoadmapButton from 'Components/TierWrapUp/BackToRoadmap';
import { useComponentWillUnmount } from 'Utils';
import {
  CustomCircularProgress,
  CustomSwitch,
} from 'Components/StyledComponents';
import AppTour, {
  AppTourStep,
  TooltipRelativePosition,
} from 'Components/AppTour';
import { AppDispatch } from 'Reducers';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { Modal as MuiModal } from '@mui/material';
import { ChangeTempo, NotifyPhaser } from 'Phaser/EventBus';
import MainApp from 'Containers/MainApp/MainApp';
import MainAppPhaser from 'Containers/MainApp/MainAppPhaser';
import { eventQueue } from 'Models/EventQueue';

const activationAccuracyValue = 95;
const minTempoForChevronFlash = 72;

const smallScreenBreakWidth = 1200;
const smallScreenBreakHeight = 900;


const lessonTutorialSetup = () => {};

const LessonPage = (props: any) => {
  // const { midiProps } = props
  // const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();

    const navigate = useNavigate(); 
    const data = useSelector((state: MainAppReducer) => state.mainAppReducer)
    // const levelData = data.levelData[data.levelSelect];
    const { 
      tierSummary,
      lessonProcessPending, 
      currentLevelCompletedAt,
      currentUserLevelData,
      phrasesTilNextTier,
      currentLevelTiers,
      lessonPlaying,
      tierSummaryRequestError,
      showWrapUp, 
      wrapUpIndex,
      lessonTimeSigNumerator,
      lessonTimeSigDenominator,
      completedPhrasesCount
    } = useSelector((state: LessonReducer) => state.lessonReducer)
    const repertoireReducerData = useSelector((state: RepertoireReducer) => state.repertoireReducer)
    const { userLevelData, hasShownIntroduction, tiersByLevels, userData } = data
    let levelSelect = data.levelSelect
    const [showTierComplete, setShowTierComplete] = useState(false)
    const [allowChevrons, setAllowChevrons] = useState(false)

    const [ accuracyPercent, setAccuracyPercent ] = useState<number | null>(0);
    const [ showAccuracy, setShowAccuracy ] = useState(false);

  const [currentTier, setCurrentTier] = useState(
    currentUserLevelData?.current_tier || 1
  );

    const [cursorIsVisible, setCursorIsVisible] = useState(true);
    const [newRepsUnlocked, setNewRepsUnlocked] = useState<any[]>([])
    const [initialLevelCompletedAt] = useState(currentUserLevelData?.level_completed_at)
    const [playButtonOverlap, setPlayButtonOverlap] = useState(0);
     
    const repertoireData = repertoireReducerData?.repertoireData
    const levelComplete = currentUserLevelData?.current_tier && currentUserLevelData?.current_tier >= currentLevelTiers
    // Guard against currentLevelCompletedAt not being a proper Date object (can happen after Redux hydration)
    const getCurrentLevelCompletedAtTime = () => {
      if (!currentLevelCompletedAt) return null;
      if (currentLevelCompletedAt instanceof Date) return currentLevelCompletedAt.getTime();
      // If it's a string (from serialization), convert to Date first
      const asDate = new Date(currentLevelCompletedAt);
      return isNaN(asDate.getTime()) ? null : asDate.getTime();
    };
    const levelCompleteFirstTime = !(currentUserLevelData?.level_completed_at) || (currentUserLevelData?.level_completed_at && new Date(currentUserLevelData?.level_completed_at).getTime() == getCurrentLevelCompletedAtTime())
    // Old logic:
    // const unitComplete =  currentUserLevelData?.level.level_number === sortBy(data.levelData, levelDatum => levelDatum.level_number).last().level_number && (currentUserLevelData?.current_tier === tiersByLevels[tiersByLevels.length - 1].tiers.length)
    // New, defensive:
    const unitComplete =
      !!currentUserLevelData?.level?.level_number &&
      currentUserLevelData.level.level_number ===
        sortBy(data.levelData ?? [], (l) => l.level_number).at(-1)?.level_number &&
      currentUserLevelData?.current_tier ===
        tiersByLevels?.at(-1)?.tiers?.length;

    // currentUserLevelData?.level.level_number === sortBy(data.levelData, levelDatum => levelDatum.level_number).last().level_number && (currentUserLevelData?.current_tier === tiersByLevels[tiersByLevels.length - 1].tiers.length)
    const [hasStarted, setHasStarted] = useState(false)
    const [carousel, setCarousel] = useState<ReactNode[]>([])
    const {
      maxHeight,
      maxWidth
    } = useMediaQueries()

    const mediaQueries = {maxHeight, maxWidth};

  const [freePlay, setFreePlay] = useState(false);
  const [tourActive, setTourActive] = useState(false);
  const [tourStepIndex, setTourStepIndex] = useState(0);
  const [tempo, setTempo] = useState(BPM);
  const [filledInChevrons, setFilledInChevrons] = useState<number>(0);
  const [debugShowTierSummary, setDebugShowTierSummary] = useState(false); // local env toggle for Tier Summary modal
  const [showTutorialVideo, setShowTutorialVideo] = useState(false); // NEW: video modal toggle

  useEffect(() => {
    setFilledInChevrons(4 - phrasesTilNextTier);
  }, [phrasesTilNextTier]);

    const LessonTutorialSteps: AppTourStep[] = [
      {
        targetId: 'playButton',
        title: 'Play Button',
        content: 'Tap the play button or hit the spacebar to start the level.',
        position: TooltipRelativePosition.LEFT,
      },
      {
        targetId: 'accuracy',
        title: 'Running Accuracy',
        content: 'Stay above 95% accuracy to collect chevrons, and keep them.',
        position: TooltipRelativePosition.LEFT,
        preStepFunction: ()=>{
          dispatch(lessonActions.updatePhrasesTilNextTier(3))
          setAccuracyPercent(95)
          setShowAccuracy(true)
        },
        postStepFunction: ()=>{
          dispatch(lessonActions.updatePhrasesTilNextTier(4))
          setAccuracyPercent(null)
        }
      },
      {
        targetId: 'accuracy',
        title: 'Running Accuracy',
        content: 'Go under 75% accuracy, and you will lose chevrons.',
        position: TooltipRelativePosition.LEFT,
        preStepFunction: ()=>{
          dispatch(lessonActions.updatePhrasesTilNextTier(4))
          setAccuracyPercent(75)
          setShowAccuracy(true)
        },
        postStepFunction: ()=>{
          dispatch(lessonActions.updatePhrasesTilNextTier(4))
          setAccuracyPercent(null)
        }
      },
      {
        targetId: `tempo`,
        title: 'Tempo',
        content: "Stay at (or above) goal tempo to enable chevrons.",
        position: TooltipRelativePosition.LEFT,
        preStepFunction: ()=>{
          dispatch(appActions.setTempo({tempo: 72}))
        },
      },
      {
        targetId: 'accuracy',
        title: 'Winning',
        content: 'Collect 4 chevrons to pass a level.',
        position: TooltipRelativePosition.LEFT,
        preStepFunction: ()=>{
          setFilledInChevrons(4)
          setAccuracyPercent(95)
          setShowAccuracy(true)
        },
        postStepFunction: ()=>{
          setFilledInChevrons(0)
          setAccuracyPercent(null)
        }
      },
      {
        targetId: `free-play`,
        title: 'Free Play',
        content: "Game Mode is enabled by default...",
        position: TooltipRelativePosition.LEFT,
      },
      {
        targetId: `free-play`,
        title: 'Free Play',
        content: "But in Free Play Mode, you can play indefinitely.",
        position: TooltipRelativePosition.RIGHT,
        preStepFunction: ()=>{
          setFreePlay(true)
        },
        postStepFunction: ()=>{
          setFreePlay(false)
        } 
      }
    ]

    const updateTier = useCallback((tier: number)=>{
      dispatch(lessonActions.updateCurrentULP({
        currentUserLevelProgress: {
          current_tier: tier
        },
      }))
    },[dispatch])

    const clearReps = useCallback(()=>{
      setNewRepsUnlocked([])
    },[setNewRepsUnlocked])

    
    useEffect(() => {
      if(showWrapUp && tierSummary?.played_notes &&  tierSummary?.played_notes > 0) {
        const newCarousel = []
        logger.info()
        if (levelComplete && repertoireData) {
          let newReps: any[] = []
          repertoireData?.forEach((rep) => {
            if (rep?.level?.level_number === currentUserLevelData?.level?.level_number) {
              newReps.push(rep)
            }
          })
          setNewRepsUnlocked(newReps)
          if(newReps.length > 0 && levelCompleteFirstTime && phrasesTilNextTier === 0) { 
            newCarousel.push(
              <RepertoireUnlocked 
                newRepsUnlocked={newReps}
                index={newCarousel.length}
              />
            )
          }
        
        }
        newCarousel.push(
          <TierWrapUp
            mediaQueries={mediaQueries}
            debugShowTierSummary={debugShowTierSummary}
          />
        )
        if(unitComplete) {
          newCarousel.push(
            <UnitComplete
              index={newCarousel.length}
            />
          )       
        }
        setCarousel(newCarousel)
      }
     
    }, [levelComplete, repertoireData, showWrapUp, levelCompleteFirstTime])

  // useEffect(()=>{
  //   logger.info("hasStarted", hasStarted)
  //   logger.info("lessonPlaying", lessonPlaying)
  //   if(!hasStarted) {
  //     setHasStarted(true)
  //   } else if(hasStarted && !lessonPlaying) {
  //     setCarousel([
  //       <PauseContainer />
  //     ])
  //   } else if (hasStarted && !lessonPlaying) {
  //     setCarousel([])
  //   }
  // }, [lessonPlaying])

    const confirmBack = useCallback(()=>{
      // Stop the lesson
      dispatch(lessonActions.setLessonPlaying({lessonPlaying: false}))
      
      // Check if user has played at least 2 phrases
      if (completedPhrasesCount >= 2) {
        // User has played enough - show wrap up (same logic as ConfirmBack's endSession)
        dispatch(lessonActions.setLessonProcessPending(true))
        // Event queue must be clear before we initiate wrap up
        eventQueue.dispatchEvents().then(() => {
          dispatch(lessonActions.initiateWrapUp())
        })
      } else {
        // User hasn't played enough - just go back to roadmap without API request
        // Clear session data and reset state
        dispatch(lessonActions.updatePhrasesTilNextTier(MIN_NUM_PHRASES))
        dispatch(lessonActions.setTierSummary(null))
        dispatch(lessonActions.setLessonProcessPending(false))
        dispatch(lessonActions.setShowWrapUp(false))
        dispatch(lessonActions.setWrapUpIndex(0))
        dispatch(lessonActions.resetCompletedPhrasesCount())
        dispatch(lessonActions.updateCurrentULP({
          currentUserLevelProgress: { play_session: { id: null } },
        }))
        navigate('/roadmap')
      }
    }, [completedPhrasesCount, dispatch, navigate])

    const replayTier = useCallback(()=>{
      logger.debug("replay tier clicked")
      clearReps()
      dispatch(lessonActions.setTierSummaryRequestError(false))
      setCarousel([])
      dispatch(lessonActions.updatePhrasesTilNextTier(MIN_NUM_PHRASES))
      setAccuracyPercent(null)
      // await dispatch(lessonActions.resetLesson())
      dispatch(lessonActions.setTierSummary(null))
      dispatch(lessonActions.createLevelSession({
        level_number:  data?.levelSelect,
        tier_number: currentUserLevelData?.current_tier || 1,
        error_recognition_mode: ERROR_RECOGNITION_MODE.MIDI
      }))
      dispatch(lessonActions.setTierSummary(null))
      dispatch(lessonActions.setWrapUpIndex(0))
      dispatch(lessonActions.setShowWrapUp(false))
      setShowAccuracy(false)
      setAccuracyPercent(null)
    },[dispatch, setAccuracyPercent, currentUserLevelData?.current_tier, data.levelSelect, setShowAccuracy, setAccuracyPercent])

    const goToNextLevelOrTier = useCallback(()=>{
      clearReps()
      setCarousel([])
      dispatch(lessonActions.updatePhrasesTilNextTier(MIN_NUM_PHRASES))
      if(levelComplete) {
        dispatch(appActions.setLevelSelect({
          levelSelect: data.levelSelect + 1
        }))
        dispatch(appActions.fetchTutorialData())
        updateTier(1)
        navigate('/tutorial')
      } else {
          dispatch(lessonActions.createLevelSession({
            level_number:  data?.levelSelect,
            tier_number: currentUserLevelData?.current_tier ? currentUserLevelData?.current_tier + 1 : 1,
            error_recognition_mode: ERROR_RECOGNITION_MODE.MIDI
          }))
      }
      dispatch(lessonActions.setTierSummary(null))
      dispatch(lessonActions.setWrapUpIndex(0))
      dispatch(lessonActions.setShowWrapUp(false))
      setShowAccuracy(false)
      setAccuracyPercent(null)
      // dispatch(lessonActions.updateCurrentULP({
      //   currentUserLevelProgress: {play_session: {id: null}},
      // }))
    },[dispatch, clearReps, updateTier, levelComplete, currentUserLevelData?.current_tier, data.levelSelect, setShowAccuracy, setAccuracyPercent])

    useEffect(()=>{
      if(showWrapUp &&  carousel.length > 0) {
        if(wrapUpIndex >= carousel.length) {
          goToNextLevelOrTier()
        } else if(wrapUpIndex < 0) {
          replayTier()
        }
      }
    },[wrapUpIndex])

    useEffect(()=>{
      console.log("showWrapUp changed", showWrapUp)
    },[showWrapUp])

    // Handle tierSummary errors - navigate back to roadmap if there's an error or no played notes
    useEffect(()=>{
      if(tierSummaryRequestError || (tierSummary && !tierSummary.played_notes)) {
        // Clear state before navigating
        dispatch(lessonActions.updatePhrasesTilNextTier(MIN_NUM_PHRASES))
        dispatch(lessonActions.setTierSummary(null))
        dispatch(lessonActions.setLessonProcessPending(false))
        dispatch(lessonActions.setShowWrapUp(false))
        dispatch(lessonActions.setWrapUpIndex(0))
        dispatch(lessonActions.resetCompletedPhrasesCount())
        navigate('/roadmap')
      }
    },[tierSummaryRequestError, tierSummary, dispatch, navigate])


  useEffect(() => {
    setCurrentTier(currentUserLevelData?.current_tier || 1);
  }, [currentUserLevelData?.current_tier]);

  const updateCurrentTier = useCallback(
    (tier: number) => {
      if (tier !== currentTier) {
        setCurrentTier(tier);
        dispatch(
          lessonActions.createLevelSession({
            level_number: data?.levelData[levelSelect].level_number,
            tier_number: tier,
            error_recognition_mode: ERROR_RECOGNITION_MODE.MIDI,
          })
        );
      }
    },
    [currentTier]
  );

  useEffect(() => {
    if (phrasesTilNextTier === 0) {
      setShowTierComplete(true);
      dispatch(
        lessonActions.setLessonPlaying({ lessonPlaying: !lessonPlaying })
      );
    }
  }, [phrasesTilNextTier]);

  const handleKeyDown = (e: any) => {
    // could also potentially check that no text fields are focued, but fine for now
    if (e.keyCode === 32) {
      //32 is space bar
      e.preventDefault(); //prevent scrollown with spacebar
    }
  };

  useEffect(() => {
    // check this... what if user-data errors?
    if (!userData?.lesson_tutorial_seenat) {
      // if (!hasShownIntroduction) {
      // dispatch(appActions.setShownIntroduction(true))
      // Still navigating \
      setTimeout(() => {
        setTourActive(true);
      }, 1000);
    } else {
      // The not ideal way of restarting webworker... actually refreshing
      // const hasReloaded = localStorage.getItem('hasReloaded');
      // if (!hasReloaded || hasReloaded == 'false') {
      // localStorage.setItem('hasReloaded', 'true');
      // window.location.reload();
      // }

      window.addEventListener('keydown', handleKeyDown);
      return () => {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, []);

    const backToRoadmap = useCallback(()=>{

      navigate('/roadmap')
    },[updateTier, currentUserLevelData?.current_tier])
    
    
    useComponentWillUnmount(()=>{
      dispatch(lessonActions.updatePhrasesTilNextTier(MIN_NUM_PHRASES))
      dispatch(lessonActions.setTierSummary(null))
      dispatch(lessonActions.setLessonProcessPending(false))
      dispatch(lessonActions.setShowWrapUp(false))
      dispatch(lessonActions.resetCompletedPhrasesCount())
    })
    
  const [isSmallScreen, setIsSmallScreen] = useState(false); //useState(window.innerWidth <= smallScreenBreakWidth || window.innerHeight <= smallScreenBreakHeight);
  const max960 = useMediaQuery('(max-width:960px)');

  useEffect(() => {
    if (max960) setIsSmallScreen(true);
    const handleResize = () => {
      setIsSmallScreen(false);
    }; //window.innerWidth <= smallScreenBreakWidth || window.innerHeight <= smallScreenBreakHeight); }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [max960]);
  
//   carousel: CarouselElementState[]
    return (
      <>
          <Box sx = {{display: 'flex', flexDirection: 'column', height: '100vh', backgroundColor: 'white'}}>
              <Header 
                confirmBack={confirmBack}
                showTierComplete={showTierComplete}
                currentTier={currentTier}
                updateCurrentTier={updateCurrentTier}
                showAccuracy={showAccuracy}
                accuracyPercent={accuracyPercent}
                levelSelect={levelSelect}
                phrasesTilNextTier={phrasesTilNextTier}
                allowChevrons={allowChevrons}
                freePlay={freePlay}
                setFreePlay={setFreePlay}
                setTourActive={setTourActive}
                tempo={tempo}
                setTempo={setTempo}
                numChevronsFilledIn={filledInChevrons}
                setShowTutorialVideo={setShowTutorialVideo}
                mobile={isSmallScreen}
              />
              <Box className="main-app-container-styles"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flex: 1,
                  overflow: 'hidden',
                }}
              >

                <MainAppPhaser
                  showTierComplete={showTierComplete}
                  currentTier={currentTier}
                  setCurrentTier={setCurrentTier}
                  updateCurrentTier={updateCurrentTier}
                  showKeyboard={false}
                  setAccuracy={setAccuracyPercent}
                  setShowAccuracy={setShowAccuracy}
                  setAllowChevrons={setAllowChevrons}
                  cursorIsVisible={cursorIsVisible}
                  freePlay={freePlay}
                  mobile={isSmallScreen}
                  playButtonOverlap={playButtonOverlap}
                // midiProps={midiProps}
                />

              </Box>
              <Box
                sx={{
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  backgroundColor: '#414753',
                  opacity: '80%',
                  visibility: carousel.length ? 'none' : 'hidden',
                  zIndex: 1999
                }}
              />
              {/* less than 0 or greater than length is what triggers next or previous action*/}
              {(wrapUpIndex >= 0 && wrapUpIndex < carousel.length) && showWrapUp && (
                <Modal
                >
                {/* Don't show back button on unit complete. (handled in component) */}
                {phrasesTilNextTier === 0 && !(unitComplete &&  wrapUpIndex === carousel.length - 1) &&
                  <BackToRoadmapButton
                    onClick={backToRoadmap}
                  />  
                }
                {!lessonProcessPending &&
                (
                  <>
                    {carousel[wrapUpIndex]}
                    {/* Check if tier is complete before showing nav (as opposed to user ending session). Also, don't show nav on unit complete. */}
                    {phrasesTilNextTier == 0 && !(unitComplete &&  wrapUpIndex === carousel.length - 1) &&
                      <Navigation
                        {...props}
                        sx={{
                          marginTop: 'auto',
                          bottom: { xs: '10px', lg: '40px' },
                        }}
                        nextButtonSx={{
                          width: { xs: '160px', md: '200px' },
                        }}
                        backText={ wrapUpIndex > 0 ? "Back" : "Replay Tier" }
                        nextText={
                          wrapUpIndex >= carousel.length - 1 ? "Keep playing" : "Next"
                        } 
                        onBack={async () => {
                          dispatch(lessonActions.setWrapUpIndex(wrapUpIndex - 1))
                        }}
                        onNext={() => {
                          dispatch(lessonActions.setWrapUpIndex(wrapUpIndex + 1))
                        }}
                        carousel={carousel.map((_,indx) => indx === wrapUpIndex ? 'active' : 'inactive')}
                      />
                    }
                  </>
                )}
                </Modal>
              )}

        {/* No idea why this is coming up on the unit complete screen, but hope this prevents it. */}
        {wrapUpIndex >= 0 &&
          wrapUpIndex < carousel.length &&
          !showWrapUp &&
          phrasesTilNextTier !== 0 && (
            <Modal
              sx={{
                height: 300,
                width: 550,
                minWidth: 550,
                minHeight: 300,
              }}
            >
              {carousel[wrapUpIndex]}
            </Modal>
          )}

              <FooterContainer 
                playButtonActive={!tourActive}
                cursorIsVisible={cursorIsVisible}
                setCursorIsVisible={setCursorIsVisible}
                debugShowTierSummary={debugShowTierSummary}
                setDebugShowTierSummary={setDebugShowTierSummary}
                setFreePlay={setFreePlay}
                freePlay={freePlay}
                mobile={isSmallScreen}
                onPlayButtonOverlapChange={setPlayButtonOverlap}
              />
          </Box>
          {process.env.REACT_APP_NODE_ENV === 'local' && debugShowTierSummary && (
            <Modal
              sx={{
                height: 'auto',
                width: 'min(92vw, 900px)',
                minHeight: 400,
              }}
            >
              <TierWrapUp
                mediaQueries={mediaQueries} 
                debugShowTierSummary={debugShowTierSummary}

              />
            </Modal>
          )}
          <AppTour 
            videoLink="https://assets.museflow.ai/videos/game-tutorials/sight-reading-trainer-tutorial.mov"
            steps={LessonTutorialSteps}
            isOpen={tourActive}
            onClose={() => {
              setTourActive(false)
              setTempo(72)
              dispatch(appActions.updateUserData({
                lesson_tutorial_seenat: new Date()
              }))
              setTourStepIndex(0)
              dispatch(lessonActions.updatePhrasesTilNextTier(4))
              setAccuracyPercent(null)
              setShowAccuracy(false)
            }}
            onStepChange={(indx: number) => setTourStepIndex(indx)}
            tooltipClassName="tour-tooltip"
            onSkipTour={() => {
              setTourActive(false)
              dispatch(appActions.updateUserData({
                lesson_tutorial_seenat: new Date()
              }))
            }}
          />
          {showTutorialVideo && (
            <MuiModal
              open={showTutorialVideo}
              sx={{
                // height: 'auto',
                width: 'min(1000px, 94vw)',
                minWidth: 320,
                minHeight: 200,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
                background: 'black',
                height: '600px',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                padding: '20px',
                maxHeight: '80vh',
                // padding: '20px'
              }}
            >
              <>
              <Box sx={{ position: 'absolute', top: 5, right: 12 }}>
                <IconButton aria-label="Close video" onClick={() => setShowTutorialVideo(false)} sx={{ color: '#CED0D4' }}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                <Box sx={{ width: '100%' }}>
                  <video
                    style={{ width: '100%', maxHeight: '70vh', borderRadius: 8 }}
                    controls
                    autoPlay
                    muted={false}
                    playsInline
                  >
                    <source src="https://assets.museflow.ai/videos/game-tutorials/sight-reading-trainer-tutorial.mov" />
                    Your browser does not support the video tag.
                  </video>
                </Box>
              </Box>
              </>
            </MuiModal>
          )}
      </>
    )
}

const accuracyColors = [
  '#00C2FF', //neutral
  '#40E16D', // green
  '#EBC334', // yellow
  '#ff7d6f',
  // 'rgba(200, 128, 114, 1.0)',// '#EB3459', // red
];

interface HeaderProps {
  levelSelect: number;
  accuracyPercent: number | null;
  showAccuracy: boolean;
  phrasesTilNextTier: number;
  allowChevrons: boolean;
  updateCurrentTier: any;
  currentTier: number;
  showTierComplete: boolean;
  confirmBack: () => void;
  freePlay: boolean;
  setFreePlay: Dispatch<SetStateAction<boolean>>;
  setTourActive: Dispatch<SetStateAction<boolean>>;
  tempo: number;
  setTempo: Dispatch<SetStateAction<number>>;
  numChevronsFilledIn: number;
  mobile: boolean;
  setShowTutorialVideo: Dispatch<SetStateAction<boolean>>;
}

interface StyledSliderProps {
  handleSliderChange: any;
  performanceTempo: number;
  sliderValue: number;
  setSliderValue: (value: number) => void;
  tempPctAdjustment: number;
  setTempPctAdjustment: (value: number) => void;
}

const StyledSlider: React.FC<StyledSliderProps> = ({
  handleSliderChange,
  performanceTempo,
  sliderValue,
  setSliderValue,
  tempPctAdjustment,
  setTempPctAdjustment,
}) => {
  // This maps for the sliding scale to be 10%-300% but middle still be 100%
  const sliderStyle = {
    color: '#6F87F1',
    '& .MuiSlider-track': {
      color: '#2D3A67',
    },
    '& .MuiSlider-rail': {
      color: '#2D3A67',
    },
  };
  return (
    <Box sx={{ textAlign: 'center', margin: '20px 30px 10px 30px' }}>
      <Slider
        sx={sliderStyle}
        value={sliderValue}
        onChange={handleSliderChange}
        min={0}
        max={100}
        aria-labelledby="continuous-slider"
        valueLabelFormat={(x) => `${Math.round(sliderValue)}%`}
      />
      <Typography>{`${Math.round(tempPctAdjustment)}%`}</Typography>
    </Box>
  );
};

const TempoExpanded = (props: any) => {
  const {
    setShowDetails,
    tempo,
    performanceTempo,
    tempoContainerRef,
    sliderValue,
    setSliderValue,
    tempPctAdjustment,
    setTempPctAdjustment,
    manualTempoInput,
    setManualTempoInput,
    setManualTempoChange,
    mapTempoToSlider,
    tempoInputRef,
    max_tempo_value,
    min_tempo_value,
    repertoireProgressSelected,
  } = props;
  const dispatch = useDispatch();

  const data = useSelector((state: MainAppReducer) => state.mainAppReducer);
  const { userData } = data;

  const topPos = 13; //getPosition().y
  const leftPos = 8; // getPosition().x

  const modalPosition = {
    left: `${leftPos - 32}px`, // Adjust as needed
    top: `${topPos + 52}px`, // Adjust so that it appears below the hamburger icon
  };

  const handleSliderChange = (event: any, newValue: number | number[]) => {
    let actualValue;
    if (Array.isArray(newValue)) {
      newValue = newValue[0];
    }
    if (newValue <= 50) {
      actualValue = 10 + 90 * (newValue / (100 / 2));
    } else {
      actualValue = 100 + 2 * 100 * ((newValue - 100 / 2) / (100 / 2)); // Linearly map to 100-300
    }
    setSliderValue(newValue);
    setTempPctAdjustment(Math.round(actualValue));
  };

  const resetTemp = () => {
    dispatch(appActions.setTempo({ tempo: performanceTempo }));
    setTempPctAdjustment(100);
    setSliderValue(50);
  };

  const detailsTitleTextStyles = {
    color: '#FFFFFF',
    fontFamily: 'Lato',
    fontSize: '15px',
    fontHeight: '700',
    lineHeight: '24px',
    letterSpacing: '1px',
    textAlign: 'left',
  };

  useEffect(() => {
    setManualTempoInput(tempo.toString());
    /*if (repertoireProgressSelected) { // This should not be be NULL, since the moment a new rep is loaded on the page, it fires request to create. So when user comes and enteres tempo, repertoireProgressSelected will be found and we can set last_tempo
      dispatch(repertoireActions.updateRepertoireDataLocal({id: repertoireProgressSelected.id, last_tempo: tempo }));
    }*/
  }, [tempo]);

  return (
    <Box
      sx={{
        position: 'absolute',
        zIndex: 10,
        ...modalPosition,
        minWidth: '350px',
        borderRadius: '8px',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.25)',
        padding: '16px',
        backgroundColor: '#050B13',
      }}
      ref={tempoContainerRef}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '-10px', // Half of the carot size to move it above the modal
          left: '40px', // Align this with the hamburger icon
          width: '0',
          height: '0',
          borderLeft: '16px solid transparent',
          borderRight: '16px solid transparent',
          borderBottom: '16px solid #050B13', // Carot color should match modal background
        }}
      />

      <Box sx={detailsTitleTextStyles}>
        <Box
          sx={{
            textAlign: 'center',
            marginTop: '6px',
            marginBottom: '16px',
            fontSize: '20px',
            position: 'relative',
          }}
        >
          Tempo Controls
        </Box>

        <Box
          sx={{
            textAlign: 'center',
            marginTop: '32px',
            marginBottom: '8px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          {tempo >= performanceTempo ? (
            <Box
              sx={{
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                gap: '7px',
              }}
            >
              <Box
                style={{
                  width: '15px',
                  height: '15px',
                  borderRadius: '50%',
                  backgroundColor: '#40E16D',
                }}
              ></Box>{' '}
              At Tempo
            </Box>
          ) : (
            <Box
              sx={{
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                gap: '7px',
              }}
            >
              <Box
                style={{
                  width: '15px',
                  height: '15px',
                  borderRadius: '50%',
                  backgroundColor: '#EB3459',
                }}
              ></Box>{' '}
              Below Tempo
            </Box>
          )}
        </Box>

        <Box
          sx={{
            textAlign: 'center',
            marginTop: '6px',
            marginBottom: '16px',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <StyledSlider
            handleSliderChange={handleSliderChange}
            performanceTempo={performanceTempo}
            sliderValue={sliderValue}
            setSliderValue={setSliderValue}
            tempPctAdjustment={tempPctAdjustment}
            setTempPctAdjustment={setTempPctAdjustment}
          />
        </Box>

        <Box
          sx={{
            textAlign: 'center',
            marginTop: '30px',
            marginBottom: '16px',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0px',
          }}
        >
          <Box
            sx={{ magin: 0, padding: 0, '&:hover': { cursor: 'pointer' } }}
            onClick={resetTemp}
          >
            <img style={{ width: '32px' }} src={Reset} />
          </Box>
          Reset
        </Box>

        <Box
          sx={{
            display: 'flex',
            borderBottom: '1px solid #31353F',
            padding: '20px 14px',
            margin: '2px 0px',
          }}
        ></Box>

        <Box
          sx={{
            textAlign: 'left',
            marginTop: '26px',
            marginBottom: '16px',
            position: 'relative',
            marginRight: 'auto',
            marginLeft: '60px',
          }}
        >
          <CustomSwitch
            checked={userData?.rep_metronome_sound}
            onChange={() => {
              dispatch(
                appActions.setRepMetronomeSound(!userData?.rep_metronome_sound)
              );
            }}
          />
          Metronome Sound
        </Box>

        <Box
          sx={{
            textAlign: 'left',
            marginTop: '6px',
            marginBottom: '16px',
            position: 'relative',
            marginRight: 'auto',
            marginLeft: '60px',
          }}
        >
          <CustomSwitch
            checked={userData?.rep_downbeats_sound}
            onChange={() => {
              dispatch(
                appActions.setRepDownbeatsSound(!userData?.rep_downbeats_sound)
              );
            }}
          />
          Accent Downbeats
        </Box>
      </Box>
    </Box>
  );
};

const Header = (props: HeaderProps) => {
  const {
    accuracyPercent,
    showAccuracy,
    allowChevrons,
    updateCurrentTier,
    currentTier,
    showTierComplete,
    confirmBack,
    freePlay,
    setFreePlay,
    setTourActive,
    tempo,
    setTempo,
    numChevronsFilledIn,
    mobile,
    setShowTutorialVideo,
  } = props;

  // const accuracyPercent = 0 // test value; comment out accuracyPercent from props above
  // const phrasesTilNextTier = 3 // test value; comment out phrasesTilNextTier from props above

  const data = useSelector((state: MainAppReducer) => state.mainAppReducer);
  const lessonData = useSelector((state: LessonReducer) => state.lessonReducer);
  const {
    currentUserLevelData,
    phrasesTilNextTier,
    currentLevelTiers,
    lessonPlaying,
  } = useSelector((state: LessonReducer) => state.lessonReducer);
  const levelSelect = data.levelSelect;
  const levelData = data.levelData;
  const levelName = levelData[levelSelect].name;
  const levelNumber = levelData[levelSelect].level_number;
  const navigate = useNavigate();

  const chevronPulseStyles = {
    height: '100%',
    animation:
      allowChevrons &&
      accuracyPercent &&
      accuracyPercent >= activationAccuracyValue
        ? `pulse ${
            60 / Math.min(tempo, minTempoForChevronFlash)
          }s infinite linear`
        : '',
  };
  const chevronContainerStyles = {
    position: 'absolute',
    height: '100%',
  };

  const positionData = [
    { til: 4, filledSrc: ChevronFilled, src: Chevron1 },
    { til: 3, filledSrc: ChevronFilled, src: Chevron1 },
    { til: 2, filledSrc: ChevronFilled, src: Chevron1 },
    { til: 1, filledSrc: ChevronLastFilled, src: ChevronSingle },
  ];

  let accuracyColor;
  if (accuracyPercent == 0) {
    accuracyColor = accuracyColors[0];
  } else if (accuracyPercent && accuracyPercent >= 95) {
    accuracyColor = accuracyColors[1];
  } else if (accuracyPercent && accuracyPercent >= 75) {
    accuracyColor = accuracyColors[2];
  } else {
    accuracyColor = accuracyColors[3];
  }

  const [infoAnchorEl, setInfoAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(infoAnchorEl);
  const handleInfoClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setInfoAnchorEl(event.currentTarget);
  };
  const handleInfoClose = () => {
    setInfoAnchorEl(null);
  };

  const lesson = useSelector((state: LessonReducer) => state.lessonReducer);

  const freePlaySelectedStyles = {
    // boxShadow: !freePlay ? '0 0 8px rgba(45, 109, 163, 0.8)': 'none'
    transform: 'scale(1.05, 1)',
    transition: 'transform 0.2s',
    overflow: 'hidden',
    '& p': {
      fontWeight: 'bold',
    },
    height: '30px',
  };

  const hiddenStyles =
    lesson.lessonPlaying && mobile
      ? {
          transform: 'translateY(-80px)',
        }
      : {
          transform: 'none',
        };

  const hiddenStylesChevrons =
    lesson.lessonPlaying && mobile
      ? {
          transform: 'translateY(80px)',
        }
      : {
          transform: 'none',
        };
        
  useEffect(() => {
    console.debug('tempo');
  }, [tempo]);

  return (
    <Box className="lesson-container-styles">
      {showTierComplete && (
        <Box
          sx={{
            height: '100%',
            width: '100%',
            visibility:
              lessonData.phrasesTilNextTier === 0 ? 'unset' : 'hidden',
            backgroundColor: '#414753',
            opacity: '70%',
            position: 'absolute',
            zIndex: '1500',
          }}
        />
      )}
      <Box
        sx={{
          // background: 'linear-gradient(90deg, black, #1D2F44)',
          background: 'linear-gradient(270deg, #1D2F44 28.99%, #071423 90.95%)',
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            marginLeft: '80px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minWidth: '465px',
            zIndex: 1100,
          }}
        >
          <Box
            sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
          >
            <Box
              sx={backcontainerStyles}
              onClick={() => {
                confirmBack();
              }}
            >
              <img style={{ height: '100%' }} src={LeftArrowIcon} />
            </Box>
            <Box className="header-text-styles">
              Level {levelNumber}: {levelName}
            </Box>
            <Box
              sx={{
                ...backcontainerStyles,
                marginLeft: '10px',
                border: '1px solid rgba(202, 124, 98, .8)',
                borderRadius: '7px',
                padding: '3px 8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                '&:hover': { cursor: 'pointer' },
              }}
              onClick={handleInfoClick}
            >
              <img style={{ height: '18px' }} src={InfoIcon} />
              <svg
                xmlns="https://www.w3.org/2000/svg"
                width="14"
                height="9"
                viewBox="0 0 14 9"
                fill="none"
              >
                <path
                  d="M6.53151 4.97725L7.32365 5.74557L8.14993 4.96948L12.7227 0.44849L13.8975 1.62326L7.34521 8.17551L0.792969 1.62326L1.96774 0.44849L6.53151 4.97725Z"
                  fill="#CA7C62"
                />
              </svg>
            </Box>

            <Menu
              id="tutorial-info-menu"
              anchorEl={infoAnchorEl}
              open={open}
              onClose={handleInfoClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
                sx: {
                  backgroundColor: 'black',
                },
              }}
              sx={{
                zIndex: 2000,
                '.MuiList-root': {
                  zIndex: 10000,
                },
                '.MuiListItemText-root': {
                  color: '#fff',
                  fontWeight: 'bold',
                },
                'bgcolor.MuiList-root-MuiMenu-list': {
                  zIndex: 2000,
                  backgroundColor: 'black',
                  color: '#fff',
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  handleInfoClose();
                  navigate('/tutorial');
                }}
              >
                <ListItemIcon sx={{ svg: { fill: MUSEFLOW_ORANGE } }}>
                  <AutorenewIcon fontSize="medium" />
                </ListItemIcon>
                <ListItemText>Level Tutorial</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleInfoClose();
                  setTourActive(true);
                }}
              >
                <ListItemIcon sx={{ svg: { fill: MUSEFLOW_ORANGE } }}>
                  <AutorenewIcon fontSize="medium" />
                </ListItemIcon>
                <ListItemText>Game Tutorial</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleInfoClose();
                  setShowTutorialVideo(true);
                }}
              >
                <ListItemIcon sx={{ svg: { fill: MUSEFLOW_ORANGE } }}>
                  <PlayCircleOutlineIcon fontSize="medium" />
                </ListItemIcon>
                <ListItemText>Watch Tutorial Video</ListItemText>
              </MenuItem>
            </Menu>
          </Box>
          <Box
            sx={{
              position: 'absolute',
              top: '44px',
              display: 'flex',
              justifyContent: 'space-between',
              width: currentLevelTiers > 1 ? '370px' : '230px',
              marginRight: '20px',
            }}
          >
            {range(1, currentLevelTiers + 1).map((tier) => {
              const hasReachedTier =
                currentUserLevelData?.highest_tier_complete &&
                currentUserLevelData?.highest_tier_complete >= tier;
              const isUnlocked =
                process.env.REACT_APP_NODE_ENV === 'local' || process.env.REACT_APP_NODE_ENV === 'dev' || 
                tier == 1 ||
                (currentUserLevelData?.highest_tier_complete &&
                  tier == currentUserLevelData?.highest_tier_complete + 1);
              console.debug('[Lesson] isUnlocked', isUnlocked, process.env.REACT_APP_NODE_ENV);
              let chosenStyles = {};
              let bgColor = colors.background.incomplete.backgroundColor;
              if (hasReachedTier) {
                chosenStyles = completeContainerStyles;
                bgColor = colors.background.complete.backgroundColor;
              } else if (isUnlocked) {
                chosenStyles = {
                  ...inProgressContainerStyles,
                  border: '3px solid #28856F',
                };
                bgColor = '#ADB1B7'; //colors.background.inProgress
              }
              return (
                <Box
                  // uuid() creates a new key every render, so React unmounts and remounts the element on every state change. With your app constantly updating (Redux, timers, etc.), it’s very easy for a re-render to happen between pointerdown and click, so the event is dispatched to a node that no longer exists and your handler never runs.
                  key={tier} // This was a uuid() before.. huge mistake made the onclick fail, very bizzare
                  sx={{
                    borderRadius: '99px',
                    backgroundColor: bgColor,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexGrow: 1,
                    height: '14px',
                    position: 'relative',
                    marginRight: '5px',
                    marginLeft: '5px',
                    '&:hover': {
                      cursor: hasReachedTier || isUnlocked ? 'pointer' : '',
                      transition:
                        tier == currentTier || hasReachedTier || isUnlocked
                          ? ''
                          : '0.3s',
                      boxShadow:
                        tier == currentTier ||
                        (tier != currentTier && !hasReachedTier && !isUnlocked)
                          ? ''
                          : '0px 0px 5px 5px rgb(70, 159, 106,.5)',
                    },
                  }}
                  onClick={() => {
                    // Weird bug that makes next tier chevrons full if clicked during tier complete dialogue
                    // so just make them not doing anything if phrases til next tier is zero
                    if (
                      (hasReachedTier || isUnlocked) &&
                      !(phrasesTilNextTier === 0)
                    ) {
                      updateCurrentTier(tier);
                    }
                  }}
                >
                  {tier == currentTier && (
                    <Box
                      sx={{
                        borderRadius: '10px',
                        backgroundColor: 'rgba(70, 159, 106, 0.2)',
                        border: '2px solid rgba(70, 159, 106, .8)',
                        position: 'absolute',
                        width: 'calc(100% + 4px)',
                        height: '18px',
                        zIndex: 10,
                      }}
                    />
                  )}
                </Box>
              );
            })}
          </Box>
        </Box>
        {mobile && (
          <TempoContainerMobile freePlay={freePlay} isSmallScreen={mobile} />
        )}
        {!mobile && <TempoContainerLarge />}
      </Box>
      <Box
        sx={{
          position: 'absolute',
          //height: '100%',
          bottom: 0,
          width: '100%',
          display: 'flex',
          alignItems: 'end',
          alignContent: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          id="free-play"
          sx={{
            height: '30px',
            width: '240px',
            background: '#414753',
            display: 'flex',
            alignContent: 'center',
            justifyContent: 'center',
            borderRadius:
              '20px 20px 0 0' /* top-left, top-right, bottom-right, bottom-left */,
            '& p': {
              color: '#fff',
              margin: '5px',
              padding: 0,
            },
            zIndex: 1000,
            // margin: '10px'
          }}
        >
          <Box
            sx={{
              // height: '30px',
              display: 'flex',
              alignContent: 'center',
              justifyContent: 'center',
              width: '120px',
              background: !freePlay ? '#6F87F1' : '#414753',
              borderRadius:
                '20px 0 0 0' /* top-left, top-right, bottom-right, bottom-left */,
              borderRightStyle: 'solid',
              borderColor: '#414753',
              '&:hover': {
                cursor: 'pointer',
              },
              ...(!freePlay ? freePlaySelectedStyles : {}),
            }}
            onClick={() => setFreePlay(false)}
          >
            <p>Game</p>
          </Box>
          <Box
            sx={{
              // height: '30px',
              display: 'flex',
              alignContent: 'center',
              justifyContent: 'center',
              width: '120px',
              background: freePlay ? '#6F87F1' : '#414753',
              borderRadius:
                '0 20px 0 0' /* top-left, top-right, bottom-right, bottom-left */,
              borderLeftStyle: 'solid',
              borderColor: '#414753',
              // boxShadow: freePlay ? '0 0 8px rgba(45, 109, 163, 0.8)': 'none'
              transform: freePlay
                ? 'scale(1.05)'
                : 'none' /* Slightly bigger */,
              transition: freePlay ? 'transform 0.2s' : 'none',
              '&:hover': {
                cursor: 'pointer',
              },
              ...(freePlay ? freePlaySelectedStyles : {}),
            }}
            onClick={() => setFreePlay(true)}
          >
            <p>Free Play</p>
          </Box>
        </Box>
      </Box>

      <Box
        id="accuracy"
        sx={{
          background:
            'linear-gradient(270deg, #1D2F44 28.99%, #071423 90.95%);',
          width: '300px',
        }}
      >
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'row',
            position: 'relative',
          }}
        >
          <Box className="accuracy-container-styles2">
            <Box className="accuracy-title-text-styles">Accuracy</Box>
            {showAccuracy && (
              <Box
                className="accuracy-text-styles"
                sx={{ color: accuracyColor }}
              >
                {accuracyPercent ? `${accuracyPercent?.toFixed(1)}%` : '--'}
              </Box>
            )}
            {!showAccuracy && <Box className="accuracy-text-styles">--</Box>}
          </Box>
          <Box
            className="first-chevron-styles"
            // sx={{
            //   ...(freePlay ? {
            //     display: 'none'
            //   } : {})
            // }}
          />
          <Box id="chevron-array-parent" sx={{
            ...(freePlay ? {
              display: 'none !important'
            }: {})
          }}>
            <div id="gradient"></div>
            <div id="chevron-bg-fill"></div>
            <div>
              {positionData.map((v, idx) => {
                const curChevronDiff = v.til - (4 - numChevronsFilledIn);
                const style =
                  curChevronDiff === 0
                    ? chevronPulseStyles
                    : { height: '100%' };
                let filledClass = curChevronDiff > 0 ? 'inner filled' : 'inner';
                let imgSrc;
                if (curChevronDiff > 0) {
                  imgSrc = v.filledSrc;
                } else if (curChevronDiff === 0) {
                  imgSrc =
                    allowChevrons &&
                    accuracyPercent &&
                    accuracyPercent >= activationAccuracyValue
                      ? v.filledSrc
                      : v.src;
                } else {
                  imgSrc = v.src;
                }
                return (
                  <Box
                    key={uuid()}
                    className="chevron"
                  >
                    <div className={filledClass} style={style}></div>
                  </Box>
                );
              })}
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const lineStyles = {
  height: '5px',
  // width: '200px',
  flexGrow: 1,
  borderRadius: '99px',
};

const circleStyles = {
  width: '26px',
  height: '26px',
  borderRadius: '50%',
};

const backcontainerStyles = {
  marginRight: '18px',
  height: '25px',
  '&:hover': {
    background: 'rgba(222,144,118,.5)',
    cursor: 'pointer',
    transition: '0.3s',
    borderRadius: '50%',
    boxShadow: '0px 0px 5px 5px rgb(222,144,118,.5)',
  },
};

const TempoContainerLarge = (props: any) => {
  const { isSmallScreen, freePlay } = props;
  const [amount, setAmount] = useState(0);
  const [message, setMessage] = useState('');
  const inputRef: any = useRef(null);
  const data = useSelector((state: MainAppReducer) => state.mainAppReducer);
  const { tempo } = data;
  const dispatch = useDispatch<AppDispatch>();
  const tempoLowerLimit = 20;
  const tempoUpperLimit = 300;
  const goalTempo = 72;

  // Press-and-hold behavior with batched Redux updates
  const { localValue: localTempo, setLocalValue: setLocalTempo, incrementHandlers, decrementHandlers } = useHoldToRepeat(
    tempo,
    (finalTempo) => {
      NotifyPhaser(ChangeTempo(finalTempo));
      dispatch(appActions.setTempo({ tempo: finalTempo }));
    },
    { min: tempoLowerLimit, max: tempoUpperLimit }
  );

  // Update input display and message when local tempo changes (including during hold)
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = localTempo;
      inputRef.current.style.width = `${String(localTempo).length}ch`;
    }
    if (localTempo < goalTempo) {
      setAmount(goalTempo - localTempo);
      setMessage('below');
    } else if (localTempo == goalTempo) {
      setAmount(0);
      setMessage('at goal');
    } else if (localTempo > goalTempo) {
      setAmount(localTempo - goalTempo);
      setMessage('above');
    }
  }, [localTempo]);

  const setTempoBlur = (val: string) => {
    let tempoVal = Math.round(parseFloat(val));
    if (isNaN(tempoVal) || tempoVal < tempoLowerLimit)
      tempoVal = tempoLowerLimit;
    if (tempoVal > tempoUpperLimit) tempoVal = tempoUpperLimit;
    setLocalTempo(tempoVal);
    NotifyPhaser(ChangeTempo(tempoVal));
    dispatch(appActions.setTempo({ tempo: tempoVal }));
  };

  return (
    <Box className="tempo-container-styles">
      {!isSmallScreen && (
        <Box
          sx={{
            textAlign: 'left',
            //fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: '700',
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            color: '#ECECEC',
            marginBottom: '10px',
            zIndex: 999,
            position: 'relative',
          }}
        >
          Tempo
        </Box>
      )}
      <Box className="tempo-row-styles">
        {isSmallScreen && (
          <Box
            sx={{
              textAlign: 'left',
              //fontFamily: 'Lato',
              fontStyle: 'normal',
              fontWeight: '700',
              fontSize: '16px',
              lineHeight: '24px',
              letterSpacing: '1px',
              textTransform: 'uppercase',
              color: '#ECECEC',
              // marginBottom: '10px',
              marginRight: '10px',
              zIndex: 999,
              position: 'relative',
            }}
          >
            Tempo
          </Box>
        )}

        <Box
          id="tempo"
          sx={{
            background: '#ADB1B7',
            //border: '2px solid #ADB1B7',
            borderRadius: '4px',
            height: '40px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            zIndex: 999,
            position: 'relative',
          }}
        >
          <Box
            className="tempo-dec-container-styles"
            sx={{ userSelect: 'none', WebkitTouchCallout: 'none', touchAction: 'manipulation' }}
            {...decrementHandlers}
          >
            <img style={{ width: '40%', pointerEvents: 'none' }} src={MinusIcon} draggable={false} />
          </Box>
          <Box
            sx={{
              marginLeft: '10px',
              marginRight: '10px',
              fontStyle: 'normal',
              fontWeight: '700',
              fontSize: '16px',
              lineHeight: '24px',
              letterSpacing: '0.01em',
              color: '#414753',
              minWidth: '80px',
            }}
          >
            {/* {localTempo}  */}
            <input
              type="text"
              ref={inputRef}
              style={{
                fontStyle: 'normal',
                fontWeight: '700',
                fontSize: '16px',
                lineHeight: '24px',
                letterSpacing: '0.01em',
                color: '#414753',
                background: '#ADB1B7',
                border: 'none',
                marginRight: '3px',
              }}
              onChange={(e) => {
                if (inputRef.current) {
                  inputRef.current.style.width = `${e.target.value.length}ch`;
                }
              }}
              onBlur={(e) => {
                setTempoBlur(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  if (inputRef.current) {
                    inputRef.current.blur();
                    setTempoBlur(e.currentTarget.value);
                  }
                }
              }}
            />
            bpm
          </Box>
          <Box
            className="tempo-inc-container-styles"
            sx={{ userSelect: 'none', WebkitTouchCallout: 'none', touchAction: 'manipulation' }}
            {...incrementHandlers}
          >
            <img style={{ width: '40%', pointerEvents: 'none' }} src={PlusIcon} draggable={false} />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          marginLeft: isSmallScreen ? '70px' : '',
          display: 'flex',
          justifyContent: 'center',
          marginTop: '8px',
          minHeight: '20px',
          alignItems: 'baseline',
        }}
      >
        {tempo <= 72 && (
          <Box
            sx={{
              backgroundColor: amount != 0 ? '#EB3459' : '#40E16D',
              opacity: amount != 0 ? '1.0' : '0.5',
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              ...(freePlay
                ? {
                    display: 'none',
                  }
                : {}),
            }}
          />
        )}
        {tempo > 72 && (
          <Box
            sx={{
              width: '10px',
              height: '20px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              opacity: amount != 0 ? '1.0' : '0.5',
              ...(freePlay
                ? {
                    display: 'none',
                  }
                : {}),
            }}
          >
            🔥
          </Box>
        )}
        <Box
          sx={{
            marginLeft: '8px',
            fontStyle: 'normal',
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '19px',
            letterSpacing: '0.01em',
            color: '#ECECEC',
            zIndex: 999,
            position: 'relative',
            display: 'flex',
            ...(freePlay
              ? {
                  display: 'none',
                }
              : {}),
          }}
        >
          {amount != 0 && <>{amount} bpm </>}
          {message} tempo
        </Box>
      </Box>

      {/* </Box> */}
    </Box>
  );
};

const TempoContainerMobile = (props: {
  isSmallScreen: boolean;
  freePlay: boolean;
}) => {
  const { freePlay, isSmallScreen } = props;
  const [amount, setAmount] = useState(0);
  const [message, setMessage] = useState('');
  const inputRef: any = useRef(null);
  const data = useSelector((state: MainAppReducer) => state.mainAppReducer);
  const { tempo } = data;
  const dispatch = useDispatch<AppDispatch>();
  const tempoLowerLimit = 20;
  const tempoUpperLimit = 300;
  const goalTempo = 72;

  // Press-and-hold behavior with batched Redux updates
  const { localValue: localTempo, setLocalValue: setLocalTempo, incrementHandlers, decrementHandlers } = useHoldToRepeat(
    tempo,
    (finalTempo) => {
      NotifyPhaser(ChangeTempo(finalTempo));
      dispatch(appActions.setTempo({ tempo: finalTempo }));
    },
    { min: tempoLowerLimit, max: tempoUpperLimit }
  );

  // Update input display and message when local tempo changes (including during hold)
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = localTempo;
    }
    if (localTempo < goalTempo) {
      setMessage('below');
    } else if (localTempo === goalTempo) {
      setMessage('at goal');
    } else if (localTempo > goalTempo) {
      setMessage('above');
    }
    setAmount(goalTempo - localTempo);
  }, [localTempo]);

  const setTempoBlur = (val: string) => {
    let tempoVal = Math.round(parseFloat(val));
    if (isNaN(tempoVal) || tempoVal < tempoLowerLimit)
      tempoVal = tempoLowerLimit;
    if (tempoVal > tempoUpperLimit) tempoVal = tempoUpperLimit;
    setLocalTempo(tempoVal);
    NotifyPhaser(ChangeTempo(tempoVal));
    dispatch(appActions.setTempo({ tempo: tempoVal }));
  };

  return (
    <Box className="tempo-container-styles">
      {!isSmallScreen && (
        <Box
          sx={{
            textAlign: 'center',
            //fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: '700',
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '1px',
            marginTop: '-5px',
            textTransform: 'uppercase',
            color: '#ECECEC',
            zIndex: 999,
            position: 'relative',
          }}
        >
          Tempo
        </Box>
      )}
      <Box className="tempo-row-styles">
        {isSmallScreen && (
          <Box
            sx={{
              textAlign: 'center',
              //fontFamily: 'Lato',
              fontStyle: 'normal',
              fontWeight: '700',
              fontSize: '16px',
              lineHeight: '24px',
              letterSpacing: '1px',
              textTransform: 'uppercase',
              color: '#ECECEC',
              marginTop: '-5px',
              // marginBottom: '10px',
              zIndex: 999,
              position: 'relative',
            }}
          >
            Tempo
          </Box>
        )}

        <Box
          sx={{
            background: '#3C54AF',
            //border: '2px solid #ADB1B7',
            borderRadius: '50px',
            height: '40px',
            width: '120px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            zIndex: 999,
            position: 'relative',
          }}
        >
          <Box
            className="tempo-dec-container-styles"
            sx={{ userSelect: 'none', WebkitTouchCallout: 'none', touchAction: 'manipulation' }}
            {...decrementHandlers}
          >
            <img style={{ width: '40%', pointerEvents: 'none' }} src={MinusIcon} draggable={false} />
          </Box>
          <Box
            sx={{
              fontStyle: 'normal',
              fontWeight: '700',
              fontSize: '16px',
              lineHeight: '24px',
              letterSpacing: '0.01em',
              color: '#414753',
            }}
          >
            <div
              //type="text"
              ref={inputRef}
              style={{
                height: '40px',
                width: '40px',
                fontStyle: 'normal',
                fontWeight: '700',
                fontSize: '16px',
                //lineHeight: "24px",
                lineHeight: '38px',
                letterSpacing: '0.01em',
                color: '#FFFFFF',
                background:
                  amount === 0 ? '#6F87F1' : amount > 0 ? '#D6415F' : '#469F6A',
                border: 'none',
                borderRadius: '50px',
                textAlign: 'center',
              }}
            >
              {localTempo}
            </div>
          </Box>
          <Box
            className="tempo-inc-container-styles"
            sx={{ userSelect: 'none', WebkitTouchCallout: 'none', touchAction: 'manipulation' }}
            {...incrementHandlers}
          >
            <img style={{ width: '40%', pointerEvents: 'none' }} src={PlusIcon} draggable={false} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LessonPage;
